// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2":"8a0a853e8a443c41","206":"6ec9e261a576e298","889":"fe2e857043993363"}[chunkId] + ".js";
};